/* import __COLOCATED_TEMPLATE__ from './schedule-delivery-drawer.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type Report from 'embercom/models/reporting/custom/report';

interface Args {
  report?: Report;
  isOpen: boolean;
  onClose: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class ReportingCustomReportScheduleDeliveryDrawer extends Component<Signature> {
  @tracked scheduleName = '';
  @tracked scheduleMessage = '';

  get isCreateDisabled() {
    return this.scheduleName.trim().length === 0;
  }

  @action
  updateScheduleName(event: Event) {
    this.scheduleName = (event.target as HTMLInputElement).value;
  }

  @action
  updateScheduleMessage(event: Event) {
    this.scheduleMessage = (event.target as HTMLTextAreaElement).value;
  }

  // Create button handler (disabled for now - will be implemented in future PR)
  @action
  handleCreate() {
    // TODO: Implement schedule creation in future PR
    // This will be called when scheduleName is non-empty
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::Report::ScheduleDeliveryDrawer': typeof ReportingCustomReportScheduleDeliveryDrawer;
    'reporting/custom/report/schedule-delivery-drawer': typeof ReportingCustomReportScheduleDeliveryDrawer;
  }
}
